// Nuxt only finds middlewares if they're in the directory `middleware`.
// Read more: https://fr.nuxtjs.org/guide/routing#middleware
import { loggerMiddleware } from '@logger/middleware'

export default loggerMiddleware
